export const ADDIN_VERSION = "2025.1.55";
